module.exports = __webpack_public_path__ + "img/img2.5175d1ea.png";